export const entityTypes = {
    loading: "LOADING_ENTITY",
    delete: "DELETE_ENTITY",
    loadedOne: "LOADED_ENTITY",
    loadedMultiple: "LOADED_ENTITYS",
    success: "SUCCESS_ENTITY",
    restore: "RESTORE_ENTITY",
    hardDelete: "HARDDELETE_ENTITY",
};
